export default __webpack_public_path__ + "static/media/FacebookSVG.d2188fd3.svg";